import React from 'react';

import { Button, Popover } from 'antd';
import EmojiPicker, { Emoji, EmojiStyle } from 'emoji-picker-react';

type Props = {
  value: string;
  disabled?: boolean;
  onEmojiPicked: (emoji: string) => void;
};

const EmojiPickerButton = ({ value, onEmojiPicked, disabled }: Props) => {
  return (
    <Popover
      content={
        <EmojiPicker onEmojiClick={emoji => onEmojiPicked(emoji.unified)} autoFocusSearch={false} />
      }
      trigger="click">
      <Button disabled={disabled} style={{ marginLeft: 10 }}>
        <Emoji unified={value} emojiStyle={EmojiStyle.APPLE} size={22} />
      </Button>
    </Popover>
  );
};

export default EmojiPickerButton;
